var setReadyMiddleware = function (dispatch) { return function (next, done) { return function (message) {
    if (message.domain !== 'iwa' || message.eventType !== 'set_ready') {
        return next(message);
    }
    dispatch({
        purpose: 'navigate',
        route: undefined,
    });
    done();
}; }; };
export default setReadyMiddleware;
//# sourceMappingURL=setReady.js.map